import { defineNuxtPlugin } from '#app'
import Toast, { type PluginOptions } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export default defineNuxtPlugin((nuxtApp) => {
  const options: PluginOptions = {
    position: 'top-right',
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    rtl: false,
    transition: 'Vue-Toastification__bounce',
    maxToasts: 5,
    newestOnTop: true,
    toastClassName: '',
    bodyClassName: '',
    containerClassName: '',
    filterBeforeCreate: (toast, toasts) => {
      // Filter out duplicate toasts
      if (toasts.filter(t => t.content === toast.content).length !== 0) {
        return false
      }
      return toast
    }
  }

  nuxtApp.vueApp.use(Toast, options)
  
  return {
    provide: {
      toast: nuxtApp.vueApp.config.globalProperties.$toast
    }
  }
}) 